import React, { useMemo, useState, useEffect, useRef } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './RichTextEditor.css';

function RichTextEditor({ value, onChange, placeholder, rows = 4 }) {
  const [editorValue, setEditorValue] = useState(value || '');
  const isUpdatingFromUser = useRef(false);

  const modules = useMemo(() => ({
    toolbar: [
      [{ 'header': [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'align': [] }],
      ['link'],
      [{ 'color': [] }, { 'background': [] }],
      ['clean']
    ],
  }), []);

  const formats = [
    'header',
    'bold', 'italic', 'underline', 'strike',
    'list', 'bullet',
    'align',
    'link',
    'color', 'background'
  ];

  // Update internal state when value prop changes (from parent/external source)
  // Skip update if the change originated from user input
  useEffect(() => {
    if (isUpdatingFromUser.current) {
      isUpdatingFromUser.current = false;
      return;
    }

    const normalizedValue = value || '';
    const normalizedEditorValue = editorValue || '';
    
    // Only update if they're truly different (handles null/undefined/empty)
    if (normalizedValue !== normalizedEditorValue) {
      setEditorValue(normalizedValue);
    }
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = (content) => {
    isUpdatingFromUser.current = true;
    setEditorValue(content);
    // Call parent onChange with the new content
    onChange(content);
  };

  return (
    <div className="rich-text-editor-wrapper">
      <ReactQuill
        theme="snow"
        value={editorValue}
        onChange={handleChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
        style={{ 
          backgroundColor: '#ffffff',
          color: '#333',
          borderRadius: '8px',
          minHeight: `${rows * 25}px`
        }}
      />
    </div>
  );
}

export default RichTextEditor;

